import React, { memo, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
import { getPrefixCls } from '../configure/utils';
const CheckboxContext = getContext(Symbols.CheckboxContext, { getPrefixCls });
const BaseCheckboxContextProvider = function CheckboxContextProvider(props) {
    const { children, checkboxGroup, getPrefixCls: getGlobalPrefixCls } = props;
    const value = useMemo(() => ({
        checkboxGroup,
        getPrefixCls: getGlobalPrefixCls,
    }), [getGlobalPrefixCls, checkboxGroup]);
    return (React.createElement(CheckboxContext.Provider, { value: value }, children));
};
BaseCheckboxContextProvider.displayName = 'CheckboxContextProvider';
export const CheckboxContextProvider = memo(BaseCheckboxContextProvider);
export default CheckboxContext;
